import { render } from "./ProviderPage.vue?vue&type=template&id=0d9dd875"
import script from "./ProviderPage.vue?vue&type=script&lang=js"
export * from "./ProviderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__